import { HTRequest, HTRequestHistory, HTRoleType } from "../../../api/entities";
import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { DateUtil, I8N } from "@eres/core";

interface Props {
	request: HTRequest;
}

class ReqHistory extends Component<Props> {
	render() {
		const { request } = this.props;
		if ( request.RequestHistory && request.RequestHistory.length > 0 ) {
			return <>
				<div className="section-title">
					<h5>{ Strings.reasons_comments }</h5>
				</div>
				<div className="card mb-4 card-ui comment-section">
					<div className="card-body">
						<ul className="list-group">
							{ request.RequestHistory.map( ( history: HTRequestHistory, index: number ) => {
								return <li key={ `ht_history_${ index }` } className="list-group-item comment-list">
                                    <span className="user-type">
                                        { history.RoleId === HTRoleType.OWNER ? Strings.landlord_lessor : Strings.tenant }</span>
									<span className="user-name">
                            <span><i
	                            className="far fa-user"/> { I8N.isRTL() ? history.CreatedByAr : history.CreatedByEn }</span>
                            <span className="comment-date" title={ Strings.date_and_time }>
                                <i className="far fa-clock"/>
	                            { DateUtil.formatDate( history.CreationDate!.asDate(), "DD/MM/YYYY hh:mm A", "en" ) }
                            </span>
                        </span>
									<span className="user-comment">{ history.Notes }</span>
								</li>;
							} ) }
						</ul>
					</div>
				</div>
			</>;
		}
		return null;
	}
}

export default ReqHistory;
